const { h, render, Component } = require('preact');
const {Portal} = require('preact-portal');

class UsageInstructions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  openPopup(){
    this.setState({open: true});
  }

  closePopup(){
    this.setState({open: false});
  }

  getUsageInstructions(){
    if (lodash.has(this.props.claimDetails, 'pitchHtml') && this.props.claimDetails.pitchHtml){
      return (
        <div
          class="ssa-information"
          dangerouslySetInnerHTML={{ __html: this.props.claimDetails.pitchHtml }}
        />
      );
    }
    return null;
  }

  render() {
    let usageInstructions = this.getUsageInstructions()
    if (usageInstructions){
      return (
        <div class="ssa-links">
          <span class="ssa-link" data-bhw="web2018_usage_instructions_link" onClick={this.openPopup}>
            {I18n.translate("js.modules.support.view_redemption_instructions")}
          </span>
          { this.state.open && (
            <Portal into="body">
              <div class="popup" data-bhw="web2018_usage_instructions_popup">
                <div>
                  <span class="icon-x" data-bhw="web2018_usage_instructions_close_button" onClick={this.closePopup}></span>
                </div>
                <div class="ssa-link-title">
                {I18n.translate("js.modules.support.redemption_instructions")}
                </div>
                {usageInstructions}
              </div>
              <div class="shadow"></div>
            </Portal>
            )
          }
        </div>
      );
    }
    return null;
  }
}
module.exports = UsageInstructions
